/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SelectInputs */

const en_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const es_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar`)
};

const fr_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner`)
};

const de_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswählen`)
};

const ja_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択`)
};

const zh_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择`)
};

const ar_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديد`)
};

const id_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih`)
};

const it_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona`)
};

const ru_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать`)
};

const pt_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar`)
};

const ko_select = /** @type {(inputs: SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {SelectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select = /** @type {((inputs?: SelectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SelectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select(inputs)
	if (locale === "es") return es_select(inputs)
	if (locale === "fr") return fr_select(inputs)
	if (locale === "de") return de_select(inputs)
	if (locale === "ja") return ja_select(inputs)
	if (locale === "zh") return zh_select(inputs)
	if (locale === "ar") return ar_select(inputs)
	if (locale === "id") return id_select(inputs)
	if (locale === "it") return it_select(inputs)
	if (locale === "ru") return ru_select(inputs)
	if (locale === "pt") return pt_select(inputs)
	return ko_select(inputs)
});